<kl-form-container
  [title]="title + (mode === 'edit' || mode === 'view' ? entity.code : '')"
  [mode]="mode"
  [pageId]="tabId ? tabId : modalId"
  [alertMessage]="alertMessage"
  [alertShow]="alertShow"
  [alertType]="alertType"
  (onCloseAlert)="alertShow = false"
  (onCommitSave)="commitSave($event)"
>
  <form #newMaterialForm="ngForm" novalidate>
    <accordion>
      <accordion-group
        [isOpen]="accordions.general_information"
        (isOpenChange)="accordions.general_information = $event"
      >
        <div accordion-heading class="clearfix">
          {{ "general_information" | translate }}
          <span class="badge badge-secondary float-right pull-right">
            <i
              class="fa"
              [ngClass]="
                accordions.general_information ? 'fa-minus' : 'fa-plus'
              "
            ></i>
          </span>
        </div>
        <div class="col-md-12 col-sm-12 row">
          <div class="col-md-6 col-sm-12">
            <div class="form-group row">
              <label for="material_code" class="col-md-3 col-sm-6">
                <small
                  >{{ "code" | translate }}
                  <b class="text-danger">*</b>
                </small>
              </label>
              <div class="col-md-9 col-sm-6">
                <div class="input-group">
                  <input
                    [disabled]="isReadOnly"
                    type="text"
                    id="material_code"
                    class="form-control form-control-sm"
                    name="material_code"
                    [(ngModel)]="entity.code"
                    (ngModelChange)="formChange(true)"
                    #materialCode="ngModel"
                    maxlength="30"
                    [class.is-invalid]="materialCode.invalid && alertShow"
                    required
                  />
                  <div
                    class="input-group-append"
                    (click)="isReadOnly ? '' : generateCode()"
                  >
                    <span
                      class="input-group-text transparent code-icon"
                      id="basic-addon2"
                    >
                      <i
                        [hidden]="!generateCodeSpin"
                        class="fal fa-spinner fa-spin fa-fw"
                      ></i>
                      <img
                        [hidden]="generateCodeSpin"
                        src="assets/img/keys.svg"
                        style="width: 20px"
                      />
                    </span>
                  </div>
                </div>
                <div
                  *ngIf="alertShow && materialCode.invalid"
                  class="errorMessage"
                >
                  {{ "important_area" | translate }}
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label for="material_name" class="col-md-3 col-sm-6">
                <small
                  >{{ "description" | translate
                  }}<b class="text-danger">*</b></small
                >
              </label>
              <div class="col-md-9 col-sm-6">
                <input
                  [disabled]="isReadOnly"
                  type="text"
                  id="material_name"
                  class="form-control form-control-sm"
                  name="material_name"
                  maxlength="100"
                  [(ngModel)]="entity.description"
                  (ngModelChange)="formChange(true)"
                  #materialName="ngModel"
                  required
                  [class.is-invalid]="materialName.invalid && alertShow"
                />
                <div
                  *ngIf="alertShow && materialName.invalid"
                  class="errorMessage"
                >
                  {{ "important_area" | translate }}
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label for="material_short_name" class="col-md-3 col-sm-6">
                <small>{{ "short_description" | translate }}</small>
              </label>
              <div class="col-md-9 col-sm-6">
                <input
                  [disabled]="isReadOnly"
                  type="text"
                  id="material_short_name"
                  class="form-control form-control-sm"
                  name="material_short_name"
                  maxlength="50"
                  (ngModelChange)="formChange(true)"
                  [(ngModel)]="entity.short_description"
                />
              </div>
            </div>
          </div>
          <div class="col-md-6 col-sm-12">
            <div class="form-group row">
              <label for="material_status" class="col-md-3 col-sm-6">
                <small>{{ "status" | translate }}</small>
              </label>
              <div class="col-md-9 col-sm-6">
                <p-dropdown
                  [emptyFilterMessage]="'not_found' | translate"
                  [disabled]="isReadOnly"
                  [options]="[
                    { label: 'ACTIVE' | translate, value: 'ACTIVE' },
                    { label: 'PASSIVE' | translate, value: 'PASSIVE' }
                  ]"
                  [(ngModel)]="entity.status"
                  (onChange)="formChange(true)"
                  name="material_status"
                  id="material_status"
                  [style]="{ width: '100%' }"
                  [placeholder]="'unselected' | translate"
                >
                </p-dropdown>
              </div>
            </div>
            <div class="form-group row">
              <label for="material_vat_rate" class="col-md-3 col-sm-6">
                <small
                  >{{ "vat_rate" | translate }}
                  <b class="text-danger">*</b>
                </small>
              </label>
              <div class="col-md-9 col-sm-6">
                <p-dropdown
                  [emptyFilterMessage]="'not_found' | translate"
                  [disabled]="isReadOnly"
                  [options]="vatGroup"
                  [(ngModel)]="entity.vat_group"
                  [dataKey]="'id'"
                  (onChange)="formChange(true)"
                  name="material_vat_rate"
                  id="material_vat_rate"
                  optionLabel="code"
                  [style]="{ width: '100%' }"
                  [placeholder]="'unselected' | translate"
                  #materialVatRate="ngModel"
                  [styleClass]="
                    materialVatRate.invalid && alertShow ? 'is-invalid' : ''
                  "
                  required
                >
                  <ng-template let-vatItem pTemplate="item">
                    <div class="ui-helper-clearfix">
                      <div style="font-size: 14px">{{ vatItem.label }}</div>
                    </div>
                  </ng-template>
                </p-dropdown>
              </div>
            </div>
          </div>
        </div>
      </accordion-group>
      <accordion-group
        [isOpen]="accordions.in_detail_information"
        (isOpenChange)="
          accordions.in_detail_information = !accordions.in_detail_information
        "
      >
        <div accordion-heading class="clearfix ui-clickable">
          {{ "in_detail_information" | translate }}
          <span class="badge badge-secondary float-right pull-right">
            <i
              class="fa"
              [ngClass]="
                accordions.in_detail_information ? 'fa-minus' : 'fa-plus'
              "
            ></i>
          </span>
        </div>
        <div class="col-md-12 col-sm-12">
          <div class="row">
            <div class="col-md-6 col-sm-12">
              <div class="form-group row">
                <label for="material_shelf_life" class="col-md-3 col-sm-6">
                  <small>{{ "product_number" | translate }}</small>
                </label>
                <div class="col-md-9 col-sm-6">
                  <input
                    [disabled]="isReadOnly"
                    type="text"
                    maxlength="20"
                    name="material_shelf_life"
                    id="material_shelf_life"
                    class="form-control form-control-sm"
                    (ngModelChange)="productNumberChange($event)"
                    [(ngModel)]="entity.product_number"
                  />
                </div>
              </div>
              <div class="form-group row">
                <label for="product_group" class="col-md-3 col-sm-6">
                  <small>{{ "product_group" | translate }}</small>
                </label>
                <div class="col-md-9 col-sm-6">
                  <p-dropdown
                    [emptyFilterMessage]="'not_found' | translate"
                    [disabled]="isReadOnly"
                    [options]="[
                      { label: 'J_RETAIL' | translate, value: 'J_RETAIL' },
                      { label: 'KL_RETAIL' | translate, value: 'KL_RETAIL' },
                      { label: 'VENUT' | translate, value: 'VENUT' }
                    ]"
                    [(ngModel)]="entity.product_group"
                    (onChange)="formChange(true)"
                    name="product_group"
                    id="product_group"
                    [style]="{ width: '100%' }"
                    [placeholder]="'unselected' | translate"
                  >
                  </p-dropdown>
                </div>
              </div>
              <div class="form-group row">
                <label for="package_type" class="col-md-3 col-sm-6">
                  <small>{{ "package_type" | translate }}</small>
                </label>
                <div class="col-md-9 col-sm-6">
                  <p-dropdown
                    [emptyFilterMessage]="'not_found' | translate"
                    [disabled]="isReadOnly"
                    [options]="packageTypes"
                    [(ngModel)]="entity.package_type"
                    (onChange)="changePackageType($event)"
                    name="package_type"
                    id="package_type"
                    [style]="{ width: '100%' }"
                    [placeholder]="'unselected' | translate"
                  >
                  </p-dropdown>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-md-3 col-sm-6">
                  <small>{{ "user_count" | translate }}</small>
                </label>
                <div class="col-md-9 col-sm-6">
                  <wj-input-number
                    [format]="'n0'"
                    [min]="1"
                    [max]="999"
                    (valueChange)="userCountValueChange($event)"
                    class="form-control form-control-sm"
                    [showSpinner]="false"
                    [(value)]="user_count"
                    [isReadOnly]="
                      isReadOnly || entity.package_type !== 'PLUS_USER'
                    "
                  >
                  </wj-input-number>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-sm-12">
              <div class="form-group row">
                <label for="material_specode_1" class="col-md-3 col-sm-6">
                  <small>{{ "specode" | translate }}</small>
                </label>
                <div class="input-group col-md-9 col-sm-6">
                  <input
                    [disabled]="isReadOnly"
                    type="text"
                    maxlength="20"
                    name="material_specode_1"
                    id="material_specode_1"
                    [(ngModel)]="entity.special_code"
                    (ngModelChange)="formChange(true)"
                    class="form-control form-control-sm"
                    aria-describedby="material_specode_1"
                  />
                  <a
                    class="inputClear"
                    [hidden]="!entity.special_code || isReadOnly"
                    (click)="entity.special_code = null"
                  >
                    <i class="fal fa-close"></i>
                  </a>
                  <div class="input-group-append">
                    <span
                      class="input-group-text transparent"
                      (click)="
                        setModal(
                          'specode',
                          'SPECODE1',
                          SpeCodeListComponent,
                          true
                        )
                      "
                    >
                      <i class="fal fa-ellipsis-h"></i>
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="material_specode_2" class="col-md-3 col-sm-6">
                  <small>{{ "specode" | translate }} 2</small>
                </label>
                <div class="input-group col-md-9 col-sm-6">
                  <input
                    [disabled]="isReadOnly"
                    type="text"
                    maxlength="20"
                    name="material_specode_2"
                    id="material_specode_2"
                    [(ngModel)]="entity.special_code2"
                    (ngModelChange)="formChange(true)"
                    class="form-control form-control-sm"
                    aria-describedby="material_specode_2"
                  />
                  <a
                    class="inputClear"
                    [hidden]="!entity.special_code2 || isReadOnly"
                    (click)="entity.special_code2 = null"
                  >
                    <i class="fal fa-close"></i>
                  </a>
                  <div class="input-group-append">
                    <span
                      class="input-group-text transparent"
                      (click)="
                        setModal(
                          'specode',
                          'SPECODE2',
                          SpeCodeListComponent,
                          true
                        )
                      "
                    >
                      <i class="fal fa-ellipsis-h"></i>
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="material_specode_3" class="col-md-3 col-sm-6">
                  <small>{{ "specode" | translate }} 3</small>
                </label>
                <div class="input-group col-md-9 col-sm-6">
                  <input
                    [disabled]="isReadOnly"
                    type="text"
                    maxlength="20"
                    name="material_specode_3"
                    id="material_specode_3"
                    [(ngModel)]="entity.special_code3"
                    (ngModelChange)="formChange(true)"
                    class="form-control form-control-sm"
                    aria-describedby="material_specode_3"
                  />
                  <a
                    class="inputClear"
                    [hidden]="!entity.special_code3 || isReadOnly"
                    (click)="entity.special_code3 = null"
                  >
                    <i class="fal fa-close"></i>
                  </a>
                  <div class="input-group-append">
                    <span
                      class="input-group-text transparent"
                      (click)="
                        setModal(
                          'specode',
                          'SPECODE3',
                          SpeCodeListComponent,
                          true
                        )
                      "
                    >
                      <i class="fal fa-ellipsis-h"></i>
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="material_specode_4" class="col-md-3 col-sm-6">
                  <small>{{ "specode" | translate }} 4</small>
                </label>
                <div class="input-group col-md-9 col-sm-6">
                  <input
                    [disabled]="isReadOnly"
                    type="text"
                    maxlength="20"
                    name="material_specode_4"
                    id="material_specode_4"
                    [(ngModel)]="entity.special_code4"
                    (ngModelChange)="formChange(true)"
                    class="form-control form-control-sm"
                    aria-describedby="material_specode_4"
                  />
                  <a
                    class="inputClear"
                    [hidden]="!entity.special_code4 || isReadOnly"
                    (click)="entity.special_code4 = null"
                  >
                    <i class="fal fa-close"></i>
                  </a>
                  <div class="input-group-append">
                    <span
                      class="input-group-text transparent"
                      (click)="
                        setModal(
                          'specode',
                          'SPECODE4',
                          SpeCodeListComponent,
                          true
                        )
                      "
                    >
                      <i class="fal fa-ellipsis-h"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </accordion-group>
      <accordion-group
        [isOpen]="accordions.unit_sets"
        (isOpenChange)="accordions.unit_sets = !accordions.unit_sets"
      >
        <div accordion-heading class="clearfix ui-clickable">
          {{ "unit_sets" | translate }}
          <span class="badge badge-secondary float-right pull-right">
            <i
              class="fa"
              [ngClass]="accordions.unit_sets ? 'fa-minus' : 'fa-plus'"
            ></i>
          </span>
        </div>
        <div class="col-md-12 col-sm-12">
          <div class="row">
            <div class="w-100">
              <div class="input-group row">
                <label class="col-md-2">
                  <small>
                    {{ "unit_set_code" | translate }}
                  </small>
                </label>
                <div class="col-md-4 mb-3">
                  <p-dropdown
                    [emptyFilterMessage]="'not_found' | translate"
                    [disabled]="isReadOnly"
                    [options]="unitSetSource"
                    name="unit_set_code"
                    [dataKey]="'id'"
                    optionLabel="description"
                    [(ngModel)]="entity.unit_set"
                    [placeholder]="'unselected' | translate"
                    (onChange)="updateUnitSet($event)"
                    [style]="{ width: '100%' }"
                    [styleClass]="
                      unitCodeSelectBox.invalid && alertShow ? 'is-invalid' : ''
                    "
                    #unitCodeSelectBox="ngModel"
                    [required]="true"
                  >
                  </p-dropdown>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-sm-12">
          <div class="row">
            <div *ngIf="accordions.unit_sets" class="col-md-12 col-sm-12">
              <wj-flex-grid
                [isReadOnly]="isReadOnly"
                #unitSetFlex
                [itemsSource]="unitSetsCollection"
              >
                <wj-flex-grid-column
                  [header]="'unit_code' | translate"
                  [binding]="'unit.code'"
                  [width]="'*'"
                  [isReadOnly]="true"
                ></wj-flex-grid-column>
                <wj-flex-grid-column
                  [header]="'unit_name' | translate"
                  [binding]="'unit.description'"
                  [width]="'1*'"
                  [isReadOnly]="true"
                ></wj-flex-grid-column>
                <wj-flex-grid-column
                  [header]="'multiplier' | translate"
                  [maxLength]="5"
                  [binding]="'multiplier'"
                  [format]="'d'"
                  [width]="'*'"
                ></wj-flex-grid-column>
              </wj-flex-grid>
            </div>
          </div>
        </div>
      </accordion-group>
    </accordion>
  </form>
</kl-form-container>
